/* tslint:disable */

declare var Object: any;
export interface UIAppInterface {
  "id"?: number;
}

export class UIApp implements UIAppInterface {
  "id": number;
  constructor(data?: UIAppInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UIApp`.
   */
  public static getModelName() {
    return "UIApp";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UIApp for dynamic purposes.
  **/
  public static factory(data: UIAppInterface): UIApp{
    return new UIApp(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UIApp',
      plural: 'UIApps',
      path: 'UIApps',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
